var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"availableCredit"},[_c('p',{staticClass:"is-size-7"},[_vm._v("Available Credit: "+_vm._s(_vm.toCurrency(_vm.availableCredit, true)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }